<template>
    <v-row
        no-gutters
        v-if="items.length"
        class="d-flex justify-center"
        :style="'max-height:' + maxHeight + ';' + 'overflow-y:auto'"
    >
        <template v-for="item in items" :key="item.id">
            <v-col :cols="$vuetify.display.mobile ? '12' : '8'">
                <v-card class="default_card" pa-0 style="margin: 5px">
                    <v-row
                        class="d-flex align-center"
                        @click.stop="$emit('to-route', item)"
                        style="cursor: pointer"
                    >
                        <v-col cols="2" class="d-flex justify-center">
                            <v-icon
                                :icon="getIcon(item)"
                                color="green"
                                size="x-large"
                                @click.stop="$emit('icon-click', item)"
                            />
                        </v-col>
                        <v-col cols="8">
                            <div style="font-weight: bold; font-size: 16pt">
                                {{ getTitle(item) }}
                            </div>
                            <div v-if="getAction(item)">
                                <v-icon
                                    size="x-small"
                                    class="mr-2"
                                    icon="$fa-edit"
                                    color="secondary"
                                />
                                {{ getAction(item) }}
                            </div>
                            <div v-if="getWording(item)">
                                <v-icon
                                    size="x-small"
                                    class="mr-2"
                                    icon="$label"
                                    color="secondary"
                                />
                                {{ getWording(item) }}
                            </div>
                            <template v-if="!hideTargets">
                                <div v-if="allTargets">
                                    <template v-for="(value, key) in getTargets(item)" :key="key">
                                        <div v-if="value">
                                            <v-icon
                                                size="x-small"
                                                class="mr-2"
                                                :icon="iconMapping[key]"
                                                color="secondary"
                                            />
                                            {{ value }}
                                        </div>
                                    </template>
                                </div>
                                <div v-else>
                                    <v-icon icon="$fa-bullseye" size="x-small" class="mr-2" />
                                    {{ getTargets(item) }}
                                </div>
                            </template>
                            <div v-if="item.companyScope && !hideStatus">
                                <span
                                    v-if="
                                        item.companyScope.accountingCompanyOwner &&
                                        item.companyScope.accountingCompanyOwner.name !== 'OSS360'
                                    "
                                >
                                    {{
                                        "Créé par " + item.companyScope.accountingCompanyOwner.name
                                    }}
                                </span>
                                <span v-else> Proposé par bobbee </span>
                            </div>
                            <div v-if="item.companyScope && !hideStatus">
                                <!-- <span v-if="status === 'EDITION'" style="font-weight: ligther; font-size: 8pt; color: #5FC9B8"> En edition</span> -->
                                <span
                                    v-if="
                                        item.companyScope.scopeSharingStatus ===
                                            'PENDING_VALIDATION' && isRootProfile
                                    "
                                    style="font-weight: ligther; font-size: 8pt; color: #f9b12a"
                                    >Partage à valider</span
                                >
                                <span
                                    v-else-if="
                                        item.companyScope.scopeSharingStatus ===
                                            'PENDING_VALIDATION' && !isRootProfile
                                    "
                                    style="font-weight: ligther; font-size: 8pt; color: #f9b12a"
                                    >Partage en attente de validation</span
                                >
                                <span
                                    v-else-if="
                                        item.companyScope.scopeSharingStatus === 'VALIDATE' &&
                                        !item.companyScope.accountingCompany
                                    "
                                    style="font-weight: ligther; font-size: 8pt; color: green"
                                    >Partage validé par bobbee</span
                                >
                            </div>

                            <template v-if="getTags(item)">
                                <v-chip-tag
                                    v-for="(tag, index) in getTags(item)"
                                    :key="'tag-' + tag + index"
                                    class="mr-1"
                                    size="small"
                                >
                                    {{ tag }}
                                </v-chip-tag>
                            </template>
                        </v-col>
                        <v-col cols="2" class="d-flex justify-space-around align-center">
                            <v-btn-icon
                                v-if="!hideEdition"
                                :icon="isReadonly(item.companyScope) ? '$oss-eye' : '$oss-edit'"
                                elevation="0"
                                size="small"
                                density="compact"
                                @click.stop="$emit('to-route', item)"
                            />
                            <v-btn-icon
                                v-if="!hideDuplication"
                                icon="$oss-duplicate"
                                elevation="0"
                                size="small"
                                density="compact"
                                @click.stop="$emit('duplicate', item)"
                            />
                            <v-btn-trash
                                v-if="!hideDeletion && enableItemDeletion(item.companyScope)"
                                size="small"
                                density="compact"
                                @click.stop="$emit('delete', item)"
                            />
                        </v-col>
                    </v-row>
                    <v-expand-transition v-if="item.id === toExpandId">
                        <div v-show="showPreview">
                            <v-divider />
                            <slot :previewItem="item"></slot>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
        </template>
        <template v-if="!hideIntersection">
            <v-col cols="8" v-intersect="onIntersectNext" v-if="patternCount > items.length">
                <v-card class="default_card" elevation="0" pa-0 style="margin: 5px">
                    <v-row class="d-flex align-center">
                        <v-col cols="2">
                            <v-skeleton-loader type="avatar" />
                        </v-col>
                        <v-col cols="9">
                            <v-skeleton-loader type="heading" class="my-3" />
                            <v-skeleton-loader type="text" class="my-auto" />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </template>
    </v-row>
    <v-row v-else class="d-flex justify-center">
        <v-col :cols="$vuetify.display.mobile ? '12' : '6'" class="my-0 pa-2">
            <v-card class="default_card ma-0" elevation="0" pa-0 style="margin: 5px">
                <v-row class="d-flex align-center">
                    <v-col cols="2" v-if="!$vuetify.display.mobile" class="text-center">
                        <v-icon :icon="getIcon({})" color="new_red" class="icon" size="x-large" />
                    </v-col>
                    <v-col :cols="$vuetify.display.mobile ? '10' : '8'">
                        <div class="d-flex align-center primary--text">
                            <span
                                :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                style="font-weight: bold; font-size: 16pt"
                            >
                                {{ parameters.emptyTitle }}
                            </span>
                        </div>
                        <div class="d-flex align-center">
                            <span :class="$vuetify.display.mobile ? 'ml-2' : ''">
                                {{ parameters.emptyMessage }}
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { User } from "@/store/store";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["intersection", "to-route", "icon-click", "duplicate", "delete"],
})
export class RuleTable extends Vue {
    @Prop({ default: "default" }) rule: string;
    @Prop({ default: [] }) items: any;
    @Prop({ default: "" }) accountingCompanyId: any;

    @Prop({ default: 0 }) patternCount: number;
    @Prop({ default: null }) pagination: any;
    @Prop({ default: false }) firstRequestDone: boolean;

    @Prop({ default: false }) hideStatus: boolean;
    @Prop({ default: false }) hideTargets: boolean;
    @Prop({ default: false }) hideEdition: boolean;
    @Prop({ default: false }) hideDeletion: boolean;
    @Prop({ default: false }) hideDuplication: boolean;
    @Prop({ default: false }) hideIntersection: boolean;

    @Prop({ default: false }) allTargets: boolean;
    @Prop({ default: "" }) toExpandId: string;
    @Prop({ default: false }) expandPreview: boolean;
    @Prop({ default: false }) showPreview: boolean;
    @Prop({ default: "84vh" }) maxHeight: string;

    @Prop({ type: Function, default: (item) => item.name || "_" }) getTitle!: (item: any) => string;
    @Prop({ type: Function, default: () => null }) actionFunction!: (item: any) => string | null;
    @Prop({ type: Function, default: () => null }) wordingFunction!: (item: any) => string | null;

    iconMapping = {
        default: "$fa-bullseye",
        company: "$oss-company",
        activity: "$oss-activity",
        taxSystem: "$fa-gear",
    };

    ruleTypes = {
        default: {
            type: "rule",
            emptyTitle: "Aucune règle",
            emptyMessage: "Vous n'avez enregistré aucune règle.",
        },
        partitionTag: {
            type: "tag",
            emptyTitle: "Aucune partition générique",
            emptyMessage: "Vous n'avez enregistré aucune partition générique.",
        },
        accountingPlan: {
            type: "rule",
            emptyTitle: "Aucun plan comptable",
            emptyMessage: "Vous n'avez enregistré aucun plan comptable.",
        },
        bookletTemplate: {
            type: "rule",
            emptyTitle: "Aucune plaquette",
            emptyMessage: "Vous n'avez enregistré aucune plaquette.",
        },
        exportTheme: {
            type: "preview",
            emptyTitle: "Aucun thème document",
            emptyMessage: "Vous n'avez enregistré aucun thème document.",
        },
        companyScope: {
            type: "rule",
            emptyTitle: "Aucun perimètre de regle",
            emptyMessage: "Vous n'avez enregistré aucun perimètre de regle.",
        },
        wordingAnalysis: {
            type: "rule",
            emptyTitle: "Aucune analyse de libellé",
            emptyMessage: "Vous n'avez enregistré aucune analyse de libellé.",
        },
        documentRule: {
            type: "rule",
            emptyTitle: "Aucune règle sur les factures",
            emptyMessage: "Vous n'avez enregistré aucune règle sur les factures.",
        },
        computedIndicator: {
            type: "rule",
            emptyTitle: "Aucun indicateur personnalisé",
            emptyMessage: "Vous n'avez enregistré aucun indicateur personnalisé.",
        },
        operatingAccount: {
            type: "rule",
            emptyTitle: "Aucun tableau personnalisé",
            emptyMessage: "Vous n'avez enregistré aucun tableau personalisé.",
        },
        exportOffice: {
            type: "file",
            emptyTitle: "Aucun export office",
            emptyMessage: "Vous n'avez enregistré aucun export office.",
        },
    };

    get parameters() {
        return this.ruleTypes[this.rule];
    }

    get type() {
        return this.parameters.type;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    enableItemDeletion(companyScope) {
        if (
            companyScope?.accountingCompanyOwner &&
            companyScope?.accountingCompanyOwner?.id === this.accountingCompanyId
        ) {
            return true;
        }
        return false;
    }

    isReadonly(companyScope) {
        const accountingCompanyId = companyScope?.accountingCompany?.id;
        const accountingCompanyOwnerId = companyScope?.accountingCompanyOwner?.id;
        if (
            accountingCompanyId == undefined &&
            accountingCompanyOwnerId !== this.accountingCompanyId
        ) {
            return true;
        }
        return false;
    }

    getIcon(item) {
        if (this.type === "file") {
            const extension = item?.filename?.split(".").pop();
            if (["xlsx", "xls", "xlsm"].includes(extension)) {
                return "$fa-file-excel";
            } else {
                return "$fa-file-word";
            }
        }
        switch (this.type) {
            case "tag":
                return "$label";
            case "preview":
                return "$oss-eye";
            default:
                return "$rule";
        }
    }

    getAction(item) {
        return this.actionFunction ? this.actionFunction(item) : false;
    }

    getWording(item) {
        return this.wordingFunction ? this.wordingFunction(item) : false;
    }

    getTags(item) {
        if (item.rules?.tags) {
            return item.rules.tags;
        }
        if (item.tags) {
            return item.tags.map((tag) => tag.name);
        }
    }

    taxSystemWording(taxSystems) {
        const tsArray = taxSystems.split(";");
        const relation = {
            RS_IS: "BIC (rs-is)",
            RS_IR: "BIC (rs-ir)",
            RN_IS: "BIC (rn-is)",
            RN_IR: "BIC (rn-ir)",
            BIC: "BIC",
            BNC: "BNC",
            RF: "RF",
        };
        return tsArray
            .map((ts) => {
                return relation[ts];
            })
            .join(", ");
    }

    getTargets(item) {
        const scope = item.companyScope ? item.companyScope : item[0];
        let targets = {
            company: "",
            activity: "",
            taxSystem: "",
            default: "",
        };
        if (!scope) {
            return targets;
        }
        if (scope.accountingCompany) {
            if (scope.clients.length) {
                const wording = scope.clients.length > 1 ? " clients: " : " client: ";
                targets.company =
                    "Pour " +
                    scope.clients.length.toString() +
                    wording +
                    scope.clients
                        .slice(0, 5)
                        .map((x) => x.name)
                        .join(", ") +
                    (scope.clients.length > 5 ? ", ..." : "");
            }
            if (scope.taxSystems) {
                targets.taxSystem =
                    "Pour les " + this.taxSystemWording(scope.taxSystems) + " de mon cabinet";
            }
            if (scope.activities && scope.activities.length) {
                const wording = scope.clients.length > 1 ? " activités: " : " activité: ";
                targets.activity =
                    "Pour " +
                    scope.activities.length.toString() +
                    wording +
                    scope.activities
                        .slice(0, 5)
                        .map((x) => x.name)
                        .join(", ") +
                    (scope.activities.length > 5 ? ", ..." : "") +
                    " de mon cabinet";
            }
            if (!targets.company && !targets.activity && !targets.taxSystem) {
                targets.default = "Pour tous les clients de mon cabinet";
            }
        } else if (scope.taxSystems) {
            targets.taxSystem =
                "Pour les " + this.taxSystemWording(scope.taxSystems) + " de tous les cabinets";
        } else if (scope.activities && scope.activities.length) {
            targets.activity =
                "Pour " +
                scope.activities.length.toString() +
                " activité(s) : " +
                scope.activities
                    .slice(0, 5)
                    .map((x) => x.name)
                    .join(", ") +
                (scope.activities.length > 5 ? ", ..." : "") +
                " de tous les cabinets";
        } else {
            targets.default = "Pour tous les clients de tous les cabinets";
        }
        if (this.allTargets) {
            return targets;
        }
        return Object.values(targets).filter((t) => t !== "")[0];
    }

    onIntersectNext(_, entries, observer) {
        if (this.firstRequestDone) {
            if (entries[0].isIntersecting) {
                this.pagination.page += 1;
                console.log(this.pagination.rowsPerPage);
            }
        }
    }
}

export default toNative(RuleTable);
</script>
